export default "__VITE_ASSET__DJRCVlPW__"